import { changeSearch, getApiHostname } from "@/util/paramutil";
import { Debug } from "@/util/debug";
import { addUserAuthSelect } from "./authutil";
import { TransitionType } from "@/components/layout/layoutType";
import { checkEmpty } from "./stringutil";
// export const weatherAPIKey = process.env.NEXT_PUBLIC_WEATHER_APIKEY;
export function fetchUtil(url: string, option: any | undefined, auth?: any, success?: Function, failed?: Function) {
  if (navigator.onLine) {
    let append_url = "";
    const userAuth = auth ? (auth as Record<string, any>) : undefined;
    const temp_option = { ...option };
    if (userAuth) {
      const data: Record<string, any> = {};
      addUserAuthSelect(data, userAuth);
      if (Object.keys(data).length > 0) {
        if (!temp_option.method || temp_option.method === "POST") {
          temp_option.method = "POST";
          temp_option.headers = { "Content-Type": "application/json" };
          if (temp_option.body) {
            const temp_data = JSON.parse(temp_option.body);
            temp_option.body = JSON.stringify({ ...data, ...temp_data });
          } else {
            temp_option.body = JSON.stringify(data);
          }
        } else {
          Object.keys(data).forEach((key, index) => {
            if (index !== 0 || url.indexOf("?") > -1) {
              append_url += "&";
            } else {
              append_url += "?";
            }
            append_url += key + "=" + data[key];
          });
        }
      }
    }

    if (temp_option.body && (!temp_option.method || temp_option.method === "POST")) {
      temp_option.method = "POST";
      temp_option.headers = { "Content-Type": "application/json" };
    }

    const mergeUrl = url + append_url;
    const apiHost = getApiHostname();
    if (mergeUrl === apiHost || mergeUrl === apiHost + "/") {
      setTimeout(() => {
        if (failed) {
          failed({ status: "503" });
        } else if (success) {
          success({ status: "503" });
        }
      }, 50);
    } else {
      Debug(mergeUrl, temp_option);
      fetch(mergeUrl, temp_option)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            switch (res.status) {
              case 400:
                return { status: "400" };
                break;
              case 401:
                // USER NOT FOUND
                return { status: "401" };
                break;
              case 403:
                // PERMISION
                return { status: "403" };
                break;
              case 404:
                // PAGE NOT FOUND
                return { status: "404" };
                break;
              default:
                Debug("fetch res", res);
                return { status: res.status + "" };
                //throw new Error("network error : " + res.status);
                break;
            }
          }
        })
        .then((getData: any) => {
          if (success != null) {
            success(getData);
          }
        })
        .catch((error) => {
          if (failed != null) {
            failed(error);
          } else {
            Debug("fetch error", error);
          }
        });
    }
  } else {
    setTimeout(() => {
      if (failed) {
        failed({ status: "503" });
      } else if (success) {
        success({ status: "503" });
      }
    }, 50);
  }
}

export function fetchHost(url: string, option: {} | undefined, auth?: any, success?: Function, failed?: Function) {
  if (checkEmpty(url) || url === "/") {
    if (failed) {
      setTimeout(() => {
        failed({ status: "503" });
      }, 50);
    }
  } else {
    fetchUtil(getApiHostname() + url, option, auth, success, failed);
  }
}

export function fetchStatusText(status?: string, checkAuth?: boolean) {
  switch (status) {
    case "401":
      if (checkAuth ?? true) {
        return "noauth_text";
      } else {
        return "nopage_text";
      }
    case "403":
      return "nopermission_text";
    case "404":
      return "nopage_text";
    default:
      return "nodata_text";
  }
}

export function fetchCommand(command: string, t?: TransitionType, auth?: any, params?: {}, success?: Function, failed?: Function) {
  const result: { url?: string; ok: string; failed: string } = { url: undefined, ok: "ok", failed: "failed" };
  switch (command) {
    case "code_reload":
      result.url = "/api/code/reload";
      result.ok = "code_reload_ok";
      result.failed = "code_reload_failed";
      break;
    default:
      break;
  }
  Debug(result);
  if (result.url) {
    fetchHost(
      result.url,
      {
        mode: "cors",
        credentials: "include",
      },
      auth,
      (data: any) => {
        if (data.status === "OK") {
          if (success) {
            success(data);
          } else {
            alert(t ? t(result.ok) : result.ok);
          }
        } else {
          if (failed) {
            failed(data);
          } else {
            alert(t ? t(result.failed) : result.failed);
          }
        }
      },
      (e: any) => {
        if (failed) {
          failed(e);
        } else {
          alert(t ? t(result.failed) : result.failed);
        }
      },
    );
  } else {
    alert(t ? t("underconstruction_text") : "underconstruction_text");
  }
}

export function commonChangeDataId(
  setDataId: Function,
  setDataMode: Function,
  pathname: string,
  prevId: string,
  id: string,
  useDefaultId?: boolean,
  mode?: string,
  modeField?: string,
  removeFields?: string[],
  historyPush?: boolean,
) {
  const search = changeSearch(modeField ?? "mode", mode, removeFields);
  const setMode = mode === "" || id === "write" ? (id === "write" ? "write" : "view") : mode;
  Debug("changeSearch : " + prevId + "," + id + "," + setMode);
  if (id != prevId || setMode) {
    let url = pathname + (id !== "" ? "/" + id : "") + search;
    if ((historyPush ?? true) && typeof history.pushState != "undefined") {
      history.pushState(null, "", url);
    } else {
      //브라우저가 지원하지 않는 경우 처리
    }
    if (id != prevId) {
      setDataId(id);
    }
    if (setMode) {
      setDataMode(setMode);
    }
  }
}
